<template>
  <div class="" style="min-height: 80vh;">
    <h1 class="text-center mt-20 space-x-5 text-3xl mb-10">
      <i class="fas fa-chart-line text-purple-700"></i>
      <span class="uppercase text-purple-700">Appmart system report</span>
    </h1>
    <div id="nav" class="text-center uppercase font-thin">
      <router-link to="/" class="hover:font-normal">Home</router-link> |
      <button @click="checkPayments()" class="hover:font-normal">
        Payments
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Home",
  computed: {
    ...mapGetters(["showPage", "paymentEmpty"]),
  },
  methods: {
    checkPayments() {
      if (this.showPage && !this.paymentEmpty) {
        this.$router.push("/payments");
      }
    },
  },
};
</script>
